import React from "react";
import "../styles/Dashboard.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BarChartIcon from "@mui/icons-material/BarChart";
import { Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DescriptionIcon from "@mui/icons-material/Description";

const Analytics = () => {
  return (
    <div className="dashboardMainDiv">
      <div className="dashboardMenu">
        <ul className="dashboardDropdownList">
          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/">
                Dashboard
              </Link>
            </li>
            <li className="listItemIcon">
              <DashboardIcon />
            </li>
          </div>

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/students">
                Students
              </Link>
            </li>
            <li className="listItemIcon">
              <SchoolIcon />
            </li>
          </div> */}

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/analytics">
                Analytics
              </Link>
            </li>
            <li className="listItemIcon">
              <BarChartIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/bonafide">
                Bonafide
              </Link>
            </li>
            <li className="listItemIcon">
              <ArticleIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/receipt">
                Receipt
              </Link>
            </li>
            <li className="listItemIcon">
              <ReceiptLongIcon />
            </li>
          </div>
          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/exams">
                Exams
              </Link>
            </li>
            <li className="listItemIcon">
              <DescriptionIcon />
            </li>
          </div>
        </ul>
      </div>
      <div className="dashboardContent">
        <div className="container dashboardContentContainer">
          <div className="row">{/* <Column {...config}/> */}</div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
